<template >
  <section id="privacy">

    <div id="main">
      <div class="container-my-helpce">
        <article class="container-my-help-articlece">
          <h2 class="b">錦龍汽車集團有限公司</h2>
          <h2 class="b">私隱政策聲明(「聲明」)</h2>
          <h2>承諾保護閣下的私隱</h2>
          <div class="subtitle">
            我們錦龍汽車集團（「錦龍」）致力遵守《個人資料（私隱）條例》（第486章）（「《私隱條例》」）下的要求以保護閣下的個人資料（定義見下）。 錦龍將確保我們的員工遵守最嚴格的安全和保密標準。
            <br /><br />
            我們強烈建議閣下仔細閱讀本聲明，以瞭解錦龍在處理從閣下收集到的個人資料方面的政策和做法。 如果閣下對此聲明有任何疑問，可以通過郵寄至香港九龍灣臨樂街19 號南豐商業中心708室或發送電子郵件至unsubscribe@kamlung.com與我們的客戶關係部聯繫。
            <br /><br />
            閣下向我們提供個人資料即表示同意本聲明以及本聲明中所載的個人資料收集、使用、存取、轉移、儲存和處理做法。
          </div>

          <div>
            <h2>收集個人資料</h2>
            <div class="subtitle">個人資料指可以直接或間接識別個人身份的任何數據或信息（「個人資料」）。 我們在不同場合收集和使用我們認爲與營運業務有關且必要的個人資料。 我們收集的個人資料類型可能包括但不限於：</div>
            <div class="content-list">
              <ul>
                <li><i class="iconfont">&#xe610;</i>聯繫信息，例如閣下的姓名、電郵地址、郵寄地址、電話號碼和傳真號碼；</li>
                <li><i class="iconfont">&#xe610;</i>唯一標識符(Unique identifiers)，例如閣下的出生日期、香港身份證號碼、護照號碼和駕照號碼（或類似）；</li>
                <li><i class="iconfont">&#xe610;</i>帳單信息，例如閣下的信用卡號、銀行帳戶信息和帳單地址； 和</li>
                <li><i class="iconfont">&#xe610;</i>有限的位置信息（例如用於幫助閣下找到附近的經銷商或合作夥伴的地址代碼）、用戶名稱和密碼。</li>
              </ul>
            </div>

            <div class="subtitle">
              有時，我們可能會從其他來源收到有關閣下的信息，我們會將這些信息添加到我們已經掌握的有關閣下的信息中，以幫助我們為閣下提供、改進和個性化我們的服務。
              <br /><br />
              一般情況下，錦龍不會故意地向18歲以下的任何人士收集其任何個人資料。但當發現有關情況發生，錦龍會將盡快刪除收集到的相關個人資料。
              <br /><br />
              如果閣下拒絕提供閣下的個人資料，則在大多數情況下閣下仍然可以使用我們的網站。 但請務必提供標有星號的個人資料。如果閣下不提供此類個人資料，我們可能無法為閣下提供某些產品或服務或閣下無法存取我們網站上某些需要先登記註冊的部份（如果有）。儘管閣下沒有義務按要求提供閣下的個人資料，但錦龍將無法提供和管理我們的產品與服務。
            </div>

            <h2>個人資料的使用</h2>
            <div class="subtitle">
              閣下或閣下的代表不時提供給錦龍的個人資料，以及錦龍收集並持有的與閣下有關的所有其他個人資料將會被用作以下用途（統稱為「該等用途」）：
            </div>
            <div class="content-list">
              <ul>
                <li><i class="iconfont">&#xe610;</i>購買錦龍及/或與錦龍相關或關聯的其他公司的產品/服務；</li>
                <li><i class="iconfont">&#xe610;</i>使用我們的網站和在線服務；</li>
                <li><i class="iconfont">&#xe610;</i>處理閣下的車輛保險申請及/或提供車輛融資或租賃；</li>
                <li><i class="iconfont">&#xe610;</i>處理對試駕和交易的要求；</li>
                <li><i class="iconfont">&#xe610;</i>驗證閣下的身份並識別閣下/閣下與我們的任何會員資格；</li>
                <li><i class="iconfont">&#xe610;</i>防止欺詐並增強閣下的帳戶或我們的在線服務的安全性，回應閣下的請求並與閣下進行溝通；</li>
                <li><i class="iconfont">&#xe610;</i>管理閣下的偏好；</li>
                <li><i class="iconfont">&#xe610;</i>為閣下提供量身定制的內容和營銷信息；</li>
                <li><i class="iconfont">&#xe610;</i>安排車輛登記、保險、車輛的租購及/或租賃；</li>
                <li><i class="iconfont">&#xe610;</i>安排車輛的保養、維修和其他售後服務；</li>
                <li><i class="iconfont">&#xe610;</i>授權服務經銷商進行維護、修理和其他售後服務；</li>
                <li><i class="iconfont">&#xe610;</i>評估、維護和改善我們的服務；</li>
                <li><i class="iconfont">&#xe610;</i>為閣下提供客戶服務，並回應閣下的查詢、反饋或要求；</li>
                <li><i class="iconfont">&#xe610;</i>進行市場分析、統計或其他調查及研究；</li>
                <li><i class="iconfont">&#xe610;</i>營銷錦龍及/或其附屬公司、子公司或關聯公司的產品及/或服務，以及與之直接相關的所有其他附帶和相關用途。，請參閱下面的「直接營銷」部分以獲取更多信息；</li>
                <li><i class="iconfont">&#xe610;</i>根據閣下的喜好訂製我們的網站及其內容；</li>
                <li><i class="iconfont">&#xe610;</i>通知閣下我們網站的任何更改或可能會影響閣下的服務的任何更改；</li>
                <li><i class="iconfont">&#xe610;</i>處理帳單和付款，確定應繳金額，並在必要時收取應繳款項；</li>
                <li><i class="iconfont">&#xe610;</i>預見並解決所提供或將要提供的任何產品/服務的問題；</li>
                <li><i class="iconfont">&#xe610;</i>遵守任何司法管轄區的適用法律；</li>
                <li><i class="iconfont">&#xe610;</i>根據適用於錦龍及/或其附屬公司、子公司或關聯公司的任何法律、法規、業務守則或指南的要求進行披露；</li>
                <li><i class="iconfont">&#xe610;</i>協助香港或其他地方的警察或其他政府或監管部門的執法及/或調查；</li>
                <li><i class="iconfont">&#xe610;</i>實現與上述用途有關的任何其他合法用途；和</li>
                <li><i class="iconfont">&#xe610;</i>與上述任何一項直接相關的其他任何用途。</li>
              </ul>
            </div>

            <div class="subtitle">
              在適用法律和法規允許的範圍內，我們也可能出於各種商業目的使用綜合地或匿名地收集數據（其無法識別任何個別客戶）。
              <br /><br />
              未經閣下的書面明示及知情同意下，錦龍無權將閣下的個人資料用於該等用途以外的其他用途。
            </div>

            <h2>用法和其他信息</h2>
            <div class="subtitle">
              除上述個人資料外，我們可能還會收集有關閣下對我們在線服務使用情況的某些信息。例如，我們可能會收集閣下用於連接到在線服務的設備的IP地址、閣下使用的操作系統和瀏覽器的類型、有關閣下來自的站點的信息、閣下訪問的在線服務的部份以及閣下接下來訪問的網站。我們或我們的第三方合作夥伴也可能使用Cookies、網絡信標(Web beacons)或其他技術來收集和儲存有關閣下訪問或使用我們的在線服務的其他信息。此外，我們稍後可能會把在線收集的使用情況和其他信息與閣下的個人資料聯繫起來。
              <br /><br />
              爲了閣下的方便，錦龍將來可能會為閣下提供通過移動應用程式和針對移動設備優化的網站享用我們的某些優惠和服務的功能。當閣下通過這些渠道與我們互動時，我們可能會收集信息，例如閣下的移動設備的獨有設備標識符(Device identifiers)、螢幕解析度和其他裝置設定、閣下的位置信息以及有關閣下如何使用移動設備的分析信息。在通過這些渠道收集信息（例如精確的地理位置信息）之前，我們可能會先徵得閣下的許可。
            </div>

            <h2>Cookies的使用</h2>
            <div class="subtitle">
              Cookies是一個小的文本文件，當閣下訪問我們的網站時，它會被放置在閣下的電腦（或其他電子設備）上。 我們使用網站上的Cookies以：
            </div>
            <div class="content-list">
              <ul>
                <li><i class="iconfont">&#xe610;</i>每當閣下訪問我們的網站時就能認出閣下；</li>
                <li><i class="iconfont">&#xe610;</i>獲取有關閣下的偏好、查看和瀏覽行為、在線活動以及互聯網使用情況的信息；</li>
                <li><i class="iconfont">&#xe610;</i>跟踪儲存在購物籃中的物品，並引導閣下完成結帳過程；</li>
                <li><i class="iconfont">&#xe610;</i>進行研究和統計分析，以幫助改善我們的服務，並幫助我們更好地瞭解我們的訪客和客戶的要求和興趣；</li>
                <li><i class="iconfont">&#xe610;</i>通過提供針對閣下的興趣量身定制的廣告，以更有效地配合我們的市場營銷和廣告活動以及我們的業務合作夥伴和廣告商的市場活動；</li>
                <li><i class="iconfont">&#xe610;</i>使閣下的在綫體驗更加高效和愉快； 和</li>
                <li><i class="iconfont">&#xe610;</i>加強安全性。</li>
              </ul>
            </div>
            <div class="subtitle">
              我們通過使用Cookies所獲得的信息未必包含閣下的個人資料。 儘管我們可能會獲得有關閣下的電腦或其他電子設備的信息，例如IP地址、瀏覽器設置、瀏覽記錄、參考/退出頁面、操作系統、日期/時間戳及/或其他網絡日誌信息，但我們可能無法識別閣下。在非個人資料與個人資料合併的情況下，出於本聲明的目的，我們將合併的資料視為個人資料。
              <br /><br />
              我們通過使用Cookies所獲得的信息未必包含閣下的個人資料。 儘管我們可能會獲得有關閣下的電腦或其他電子設備的信息，例如IP地址、瀏覽器設置、瀏覽記錄、參考/退出頁面、操作系統、日期/時間戳及/或其他網絡日誌信息，但我們可能無法識別閣下。在非個人資料與個人資料合併的情況下，出於本聲明的目的，我們將合併的資料視為個人資料。
              <br /><br />
              如果要禁止使用Cookies，閣下可以在自己的網絡瀏覽器上操作。 如果禁用Cookies，則閣下接受可能無法使用我們的網站的某些功能。
            </div>

            <h2>直接營銷</h2>
            <div class="subtitle">
              錦龍計劃將閣下的個人資料用於錦龍及/或其子公司、關聯公司和關連公司進行的直接營銷，為此，錦龍持有的閣下的個人資料可能會提供給任何我們的關聯公司、子公司或關連公司以用於直接營銷。 本聲明列明我們打算使用的個人資料的種類和營銷主題的類別。但是，我們僅在獲得閣下的同意或《私隱條例》允許的情況下使用閣下的個人資料。
              <br /><br />
              為進行直接營銷，錦龍打算將閣下的姓名和聯繫信息用於（i）提供我們可能會向閣下提供，或者閣下可能會不時要求我們提供的產品及/或服務及（ii）營銷、促銷和客戶關係管理的目的，包括但不限於：
            </div>
            <div class="content-list">
              <ul>
                <li><i class="iconfont">&#xe610;</i>向閣下提供與我們的產品和服務有關的最新的優惠和促銷信息；</li>
                <li><i class="iconfont">&#xe610;</i>進行市場調查；</li>
                <li><i class="iconfont">&#xe610;</i>品牌活動；</li>
                <li><i class="iconfont">&#xe610;</i>車展和顧客活動；</li>
                <li><i class="iconfont">&#xe610;</i>與汽車有關的服務和產品；</li>
                <li><i class="iconfont">&#xe610;</i>與汽車有關的保險；</li>
                <li><i class="iconfont">&#xe610;</i>汽車銷售和售後服務； 和</li>
                <li><i class="iconfont">&#xe610;</i>兌換禮品、忠誠、獎勵或專享計劃。</li>
              </ul>
            </div>

            <div class="subtitle">
              錦龍採取了適當的措施，使閣下可以選擇「退出」，以拒絕允許閣下的個人資料用於上述任何直接營銷用途。閣下可以通過郵寄至香港九龍灣臨樂街19 號南豐商業中心708室或發送電子郵件至unsubscribe@kamlung.com與我們的客戶關係部聯繫，免費要求退出允許閣下的個人資料用於直接營銷用途。
            </div>

            <h2>披露個人資料</h2>
            <div class="subtitle">
              提供給錦龍的個人資料將被保密。錦龍致力保護閣下的私隱，不向第三方出售或交易閣下的個人資料。但是，因應任何該等用途，我們可能會向所有或任何以下個人或實體在必要的程度下披露該等資料，或者該等資料可能會得到所有或任何以下個人或實體在必要的程度下的接觸或瞭解：
            </div>
            <div class="content-list">
              <ul>
                <li><i class="iconfont">&#xe610;</i>為我們處理資料、提供資料庫維護或資料輸入服務或以其他方式向我們提供行政、電信、電腦、支付、數據處理或儲存、技術支援或其他產品/服務的代理商、服務提供商、承包商和顧問；</li>
                <li><i class="iconfont">&#xe610;</i>需要知道這些資料以便為我們作資料處理或履行其職責，並獲我們正式授權的員工；</li>
                <li><i class="iconfont">&#xe610;</i>我們的關聯公司、子公司或關連公司，以用於上述該等用途，以及與之相關的所有其他附帶和關聯用途，以達到其收集的目的（受制於任何與上述「直接營銷」有關的同意要求）；</li>
                <li><i class="iconfont">&#xe610;</i>其他公司以為閣下帶來聯合品牌的服務、產品或計劃；</li>
                <li><i class="iconfont">&#xe610;</i>錦龍的權利或業務的任何實際或建議的擬承讓人、受讓人、參與者或次參與者；和</li>
                <li><i class="iconfont">&#xe610;</i>我們的專業顧問，包括財務顧問和法律顧問。</li>
              </ul>
            </div>

            <div class="subtitle">
              在以下情況下，錦龍可能會向第三方披露個人資料：
            </div>
            <div class="content-list">
              <ul>
                <li><i class="iconfont">&#xe610;</i>在法律、法規、對錦龍具有約束力的守則或執法機構或法院命令所要求的情況下；</li>
                <li><i class="iconfont">&#xe610;</i>當我們真誠地認為有必要進行披露以保護閣下或他人的安全，或為發現、調查或預防包括欺詐在內的非法活動時；</li>
                <li><i class="iconfont">&#xe610;</i>由於出售、合併、收購、整合、集團重組、控制權變更、清盤或資產轉讓；</li>
                <li><i class="iconfont">&#xe610;</i>錦龍需要保護和捍衛其合法權利和財産；和</li>
                <li><i class="iconfont">&#xe610;</i>錦龍認爲有必要這樣做，以遵守任何適用的法律和法規，或具有管轄權的法院作出的任何命令或指示。</li>
              </ul>
            </div>

            <div class="subtitle">
              錦龍應確保任何披露已根據本聲明進行且均已正確記錄在案。其他對閣下個人資料的披露則只有在我們獲得閣下的同意或法律要求下才能進行。
            </div>

            <h2>個人資料的儲存</h2>
            <div class="subtitle">
              由於我們業務涵蓋國際，我們可能會在香港以外地區處理和儲存閣下的個人資料。 因此，我們可能會將閣下的個人資料轉移到我們在香港以外的分支機構、子公司或聯營公司以進行資料處理和儲存。 這可能涉及將閣下的個人資料轉移到個人資料保護級別可能不同的司法管轄區。
              <br /><br />
              閣下的資料可能會被轉移和儲存於安全的錦龍的系統，或與錦龍或錦龍附屬公司簽訂合同的第三方系統中。通過將個人資料提交給錦龍或使用任何錦龍的網站，即表示閣下理解並同意有關轉移。
            </div>

            <h2>資料保留</h2>
            <div class="subtitle">
              從閣下那裡收集的所有個人資料可能會被保留一段足以達到收集用途的時間，或在適用法律要求的時限內被保留。
              <br /><br />
              如果任何執法機構或監管機構要求我們保留任何錦龍收集的個人資料以用於主動調查犯罪，則相關個人資料可能會被保留至相關執法部門或監管機構收集此類資料。
            </div>

            <h2>數據安全</h2>
            <div class="subtitle">
              錦龍致力採取適當措施以確保閣下的個人資料受到保護。 我們使用各種實際、技術和組織措施來保護閣下的個人資料，防止未經授權或意外的存取、處理、刪除或其他使用。
              <br /><br />
              錦龍的所有員工、承包商和服務提供商都必須嚴格遵守本聲明。 只有錦龍或其授權的第三方可存取所有閣下提供的個人資料，而這些人員已得到指示在存取此類個人資料時須遵守本聲明的條款。 閣下可以放心其個人資料將僅保留達到實現收集用途所必需的時間。
              <br /><br />
              但是請注意，互聯網上的數據傳輸是不能保證完全安全的。 因此，我們不保證閣下通過互聯網傳輸給我們或我們通過互聯網傳輸給閣下的任何資料的安全性。
            </div>

            <h2>第三方網站</h2>
            <div class="subtitle">
              本聲明不適用於可能從我們的網站連接的第三方網站，或與我們關聯的任何其他廣播連接的第三方網站。
            </div>

            <h2>有關其他人的信息</h2>
            <div class="subtitle">
              如果閣下代表其他人給我們提供信息，則閣下確認其他人已任命閣下代表他或她行事，並同意閣下可以：
            </div>
            <div class="content-list">
              <ul>
                <li><i class="iconfont">&#xe610;</i>代表他或她同意處理他或她的個人資料；</li>
                <li><i class="iconfont">&#xe610;</i>代表他或她收到任何資料保護通知；</li>
                <li><i class="iconfont">&#xe610;</i>同意將其個人資料轉移到境外； 和</li>
                <li><i class="iconfont">&#xe610;</i>同意處理其個人資料或其他資料。</li>
              </ul>
            </div>

            <h2>聲明的變更</h2>
            <div class="subtitle">
              錦龍特此明確保留隨時於錦龍認為有必要的時候更新或修改本聲明的權利，並強烈建議閣下經常閱讀本聲明。 如果錦龍決定更新或修改本聲明，錦龍將在www.kamlung.com及/或錦龍認為適當的其他地方發佈這些更改，以便閣下知道我們的聲明的任何更新。
              <br /><br />
              如果錦龍對本聲明做出重大更改，錦龍將在我們的網站或通過電子郵件通知閣下。
            </div>

            <h2>更新閣下的個人資料</h2>
            <div class="subtitle">
              閣下有權隨時要求我們確認錦龍有否收集閣下的個人資料，如有，則閣下有權存取由我們持有的閣下的個人資料，或要求更正或刪除此類資料，或撤回閣下關於未來錦龍使用閣下個人資料的同意。 對於此類資料的存取或更正或删除請求，我們可能會收取合理的費用。
              <br /><br />
              閣下可以將其書面要求發送至香港九龍灣臨樂街19 號南豐商業中心708室給我們的客戶關係部，或通過電子郵件發送至unsubscribe@kamlung.com。
              <br /><br />
              如果閣下希望存取或修改閣下的個人資料，錦龍可能會要求閣下提供身份證明以及所有用於確定身份的必要信息。
            </div>

            <h2>其他</h2>
            <div class="subtitle">
              本聲明應與錦龍發佈的其他文件一起閱讀。 如果本聲明中的任何規定與錦龍的其他文件不一致，則以本聲明中的規定為準。
              <br /><br />
              本聲明受香港法律管轄並根據其解釋。
              <br /><br />
              本聲明提供中文和英文版本。 如果兩個版本之間存在不一致之處，請以英文版本爲準。
            </div>

            <div class="subtitle">
              版權所有©2020錦龍汽車集團
              <br /><br />
              保留所有權利
            </div>

          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "privacyPolicy",
  data () {
    return {};
  },
  components: {},
  mounted () { },
  methods: {},
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
#privacy {
  font-family: '微軟正黑體', '新細明體', 'AudiTypeNormal', Verdana, Geneva, sans-serif !important;
  margin: 0 auto;
  counter-reset: num;
  width: 86%;
  font-size: 17px;
  line-height: 26px;

  h2 {
    margin: 18px 0;
    font-size: 21px;
    font-weight: 700;
    letter-spacing: 0.44px;
    line-height: 30px;
  }

  .subtitle {
    margin-bottom: 18px;
  }

  // .content {
  // line-height: 22px;
  // margin-bottom: 38px;
  // }
  .content-list {
    margin-bottom: 42px;
    padding-left: 4%;
    padding-right: 4%;

    ul {
      li {
        margin-top: 6px;
        line-height: 24px;

        .iconfont {
          font-size: 17px;
          font-weight: 400;
          margin-right: 12px;
        }
      }
    }
  }

  @media (max-width: 1023px) and (min-width: 768px) {
    .content-list {
      margin-bottom: 48px;
    }
  }

  @media (max-width: 1439px) and (min-width: 1024px) {
    .content-list {
      margin-bottom: 60px;
    }
  }

  @media (max-width: 1919px) and (min-width: 1440px) {
    .content-list {
      margin-bottom: 78px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy/PrivacyPolicyCn.vue